import { AsyncPipe, DatePipe } from '@angular/common';
import { HttpParams, httpResource } from '@angular/common/http';
import { Component, inject, signal, } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule, } from '@angular/material/paginator';
import { ActivatedRoute, Data, Router, RouterModule } from '@angular/router';
import { ListComponent } from '@components/list/list.component';
import { PromptComponent } from '@components/prompt/prompt.component';
import { environment } from '@environment';
import { Case, ItemListResponse, Placename } from '@models';
import { LinkPipe, ResolveUserPipe } from '@pipes';
import { AuthService, CaseService, NotificationService, PlacenameService, TitleService } from '@services';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-case-item',
  imports: [
    DatePipe,
    RouterModule,

    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatPaginatorModule,
    MatMenuModule,
    MatTooltipModule,

    LinkPipe,
    ResolveUserPipe,
    AsyncPipe,

    ListComponent,
  ],
  templateUrl: './item.component.html',
  styleUrl: './item.component.scss'
})
export class CaseItemComponent {
  route = inject(ActivatedRoute);
  dialog = inject(MatDialog);
  authService = inject(AuthService);
  placenameService = inject(PlacenameService);
  notificationService = inject(NotificationService);
  caseService = inject(CaseService);
  titleService = inject(TitleService);
  router = inject(Router);

  case = signal<Case>(this.route.snapshot.data['case']);

  page = signal(0);
  placenames = httpResource<ItemListResponse<Placename>>(() => {
    const httpParams = new HttpParams()
      .set('skip', this.page() * 10)
      .set('take', 10)
      .set('count', true)
      .set('order', 'created:desc')
      .set('case', this.case().id);

    return `${environment.kinkoHost}/placename/?${httpParams.toString()}`;
  });

  constructor() {
    this.titleService.setTitle(this.case().title);

    this.route.data.subscribe((d: Data) => {
      if (d['case'].id === this.case().id) {
        return;
      }

      this.case.set(d['case']);
    });
  }

  delete() {
    const dialogRef = this.dialog.open(PromptComponent, {
      minWidth: '360px',
      width: '480px',
      data: {
        title: 'Delete case',
        content:
          'Confirm to delete this case. This action can not be undone.',
      },
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (!result) {
        return;
      }

      this.caseService.delete(this.case().id).subscribe({
        next: () => {
          this.router.navigate(['/placename/case']).finally(() => {
            this.notificationService.success('Case deleted successfully.');
          });
        },
        error: (err) => {
          this.notificationService.error('Failed to delete case.');
          console.error(err);
        }
      });
    });
  }
}
